"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { getSlugAndRouteName } from "../../utils/Functions";
import { routeVariables, sanitizeUrlSegment } from "@/utils/routestrings";
const BreadCrumbs = ({
  industryId,
  industryName,
  subIndustryId,
  subIndustryName,
  programName
}: any) => {
  const pathname = usePathname();

  // Use fallback values for required fields
  const safeIndustryName = industryName ?? "Industry";
  const safeSubIndustryName = subIndustryName ?? "Sub Industry";
  const safeProgramName = programName ?? "Program";
  const {
    routeId,
    isIndustryPage,
    isSubIndustryPage
  } = getSlugAndRouteName(pathname.toString());
  if (isIndustryPage) {
    return <div className="section__container--small breadcrumbs-container">
        <ul className="breadcrumbs">
          <li className="ellip">
            <Link href="/" className="">
              <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                <path d="M10.4722 2.128C10.1942 1.91179 9.85214 1.7944 9.5 1.7944C9.14787 1.7944 8.80578 1.91179 8.52783 2.128L1.8905 7.28967C1.29517 7.75438 1.62292 8.70834 2.37738 8.70834H3.16667V15.0417C3.16667 15.4616 3.33348 15.8643 3.63041 16.1613C3.92735 16.4582 4.33007 16.625 4.75 16.625H7.91667V11.875C7.91667 11.4551 8.08348 11.0523 8.38042 10.7554C8.67735 10.4585 9.08007 10.2917 9.5 10.2917C9.91993 10.2917 10.3227 10.4585 10.6196 10.7554C10.9165 11.0523 11.0833 11.4551 11.0833 11.875V16.625H14.25C14.6699 16.625 15.0727 16.4582 15.3696 16.1613C15.6665 15.8643 15.8333 15.4616 15.8333 15.0417V8.70834H16.6226C17.3763 8.70834 17.7056 7.75438 17.1095 7.29046L10.4722 2.128Z" fill="#686C7A" />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="6" height="9" viewBox="0 0 6 9" fill="none" style={{
              marginLeft: "6px"
            }}>
                <path opacity="0.6" d="M1 0.5L5 4.5L1 8.5" stroke="#686C7A" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </Link>
          </li>
          <li className="active">
            <Link className="breadcrumbs-list" href="#">
              {safeIndustryName}
            </Link>
          </li>
        </ul>
      </div>;
  }
  if (isSubIndustryPage) {
    return <div className="section__container--small breadcrumbs-container">
        <ul className="breadcrumbs">
          <li className="ellip">
            <Link href="/" className="">
              <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                <path d="M10.4722 2.128C10.1942 1.91179 9.85214 1.7944 9.5 1.7944C9.14787 1.7944 8.80578 1.91179 8.52783 2.128L1.8905 7.28967C1.29517 7.75438 1.62292 8.70834 2.37738 8.70834H3.16667V15.0417C3.16667 15.4616 3.33348 15.8643 3.63041 16.1613C3.92735 16.4582 4.33007 16.625 4.75 16.625H7.91667V11.875C7.91667 11.4551 8.08348 11.0523 8.38042 10.7554C8.67735 10.4585 9.08007 10.2917 9.5 10.2917C9.91993 10.2917 10.3227 10.4585 10.6196 10.7554C10.9165 11.0523 11.0833 11.4551 11.0833 11.875V16.625H14.25C14.6699 16.625 15.0727 16.4582 15.3696 16.1613C15.6665 15.8643 15.8333 15.4616 15.8333 15.0417V8.70834H16.6226C17.3763 8.70834 17.7056 7.75438 17.1095 7.29046L10.4722 2.128Z" fill="#686C7A" />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="6" height="9" viewBox="0 0 6 9" fill="none" style={{
              marginLeft: "6px"
            }}>
                <path opacity="0.6" d="M1 0.5L5 4.5L1 8.5" stroke="#686C7A" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </Link>
          </li>
          <li className="">
            <Link className="breadcrumbs-list" href={`/in/${sanitizeUrlSegment(industryName)}${routeVariables.PREMIUMINDUSTRY}${industryId}`}>
              {safeIndustryName}
            </Link>
          </li>
          <svg xmlns="http://www.w3.org/2000/svg" width="6" height="9" viewBox="0 0 6 9" fill="none" style={{
          marginLeft: "6px"
        }}>
            <path opacity="0.6" d="M1 0.5L5 4.5L1 8.5" stroke="#686C7A" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <li className="active">
            <Link className="breadcrumbs-list" href="#">
              {safeSubIndustryName}
            </Link>
          </li>
        </ul>
      </div>;
  }
  const createBreadCrumbs = () => {
    return <>
        <li className="">
          <Link className="breadcrumbs-list" href={`/in/${sanitizeUrlSegment(industryName)}${routeVariables.PREMIUMINDUSTRY}${industryId}`} data-sentry-element="Link" data-sentry-source-file="BreadCrumbs.tsx">
            {safeIndustryName}
            <svg xmlns="http://www.w3.org/2000/svg" width="6" height="9" viewBox="0 0 6 9" fill="none" style={{
            marginLeft: "6px"
          }} data-sentry-element="svg" data-sentry-source-file="BreadCrumbs.tsx">
              <path opacity="0.6" d="M1 0.5L5 4.5L1 8.5" stroke="#686C7A" strokeLinecap="round" strokeLinejoin="round" data-sentry-element="path" data-sentry-source-file="BreadCrumbs.tsx" />
            </svg>
          </Link>
        </li>
        <li className="">
          <Link className="breadcrumbs-list" href={`/in/${sanitizeUrlSegment(subIndustryName)}${routeVariables.PREMIUMSUBINDUSTRY}${subIndustryId}`} data-sentry-element="Link" data-sentry-source-file="BreadCrumbs.tsx">
            {safeSubIndustryName}
            <svg xmlns="http://www.w3.org/2000/svg" width="6" height="9" viewBox="0 0 6 9" fill="none" style={{
            marginLeft: "6px"
          }} data-sentry-element="svg" data-sentry-source-file="BreadCrumbs.tsx">
              <path opacity="0.6" d="M1 0.5L5 4.5L1 8.5" stroke="#686C7A" strokeLinecap="round" strokeLinejoin="round" data-sentry-element="path" data-sentry-source-file="BreadCrumbs.tsx" />
            </svg>
          </Link>
        </li>
        <li className="active">
          <Link className="breadcrumbs-list" href="#" data-sentry-element="Link" data-sentry-source-file="BreadCrumbs.tsx">
            {safeProgramName}
          </Link>
        </li>
      </>;
  };
  return <div className="section__container--small breadcrumbs-container" data-sentry-component="BreadCrumbs" data-sentry-source-file="BreadCrumbs.tsx">
      <ul className="breadcrumbs">
        <li className="ellip">
          <Link href="/" className="" data-sentry-element="Link" data-sentry-source-file="BreadCrumbs.tsx">
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none" data-sentry-element="svg" data-sentry-source-file="BreadCrumbs.tsx">
              <path d="M10.4722 2.128C10.1942 1.91179 9.85214 1.7944 9.5 1.7944C9.14787 1.7944 8.80578 1.91179 8.52783 2.128L1.8905 7.28967C1.29517 7.75438 1.62292 8.70834 2.37738 8.70834H3.16667V15.0417C3.16667 15.4616 3.33348 15.8643 3.63041 16.1613C3.92735 16.4582 4.33007 16.625 4.75 16.625H7.91667V11.875C7.91667 11.4551 8.08348 11.0523 8.38042 10.7554C8.67735 10.4585 9.08007 10.2917 9.5 10.2917C9.91993 10.2917 10.3227 10.4585 10.6196 10.7554C10.9165 11.0523 11.0833 11.4551 11.0833 11.875V16.625H14.25C14.6699 16.625 15.0727 16.4582 15.3696 16.1613C15.6665 15.8643 15.8333 15.4616 15.8333 15.0417V8.70834H16.6226C17.3763 8.70834 17.7056 7.75438 17.1095 7.29046L10.4722 2.128Z" fill="#686C7A" data-sentry-element="path" data-sentry-source-file="BreadCrumbs.tsx" />
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="6" height="9" viewBox="0 0 6 9" fill="none" style={{
            marginLeft: "6px"
          }} data-sentry-element="svg" data-sentry-source-file="BreadCrumbs.tsx">
              <path opacity="0.6" d="M1 0.5L5 4.5L1 8.5" stroke="#686C7A" strokeLinecap="round" strokeLinejoin="round" data-sentry-element="path" data-sentry-source-file="BreadCrumbs.tsx" />
            </svg>
          </Link>
        </li>
        {createBreadCrumbs()}
      </ul>
    </div>;
};
export default BreadCrumbs;